exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EnrollmentWizard.hidden{visibility:hidden}.EnrollmentWizardNavigation{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin:32px auto 48px auto}.EnrollmentWizardNavigation Button{-webkit-margin-start:16px;margin-inline-start:16px}", ""]);

// exports
